import React from 'react'
import { FooterComponent, NavbarComponent } from '../../SharedComponents'
import ContactSection from './ContactSection'
import ProductSection1 from './ProductSection1'
import ProductSection2 from './ProductSection2'
import './ProductsPage.css'
import TitleSection from './TitleSection'

export default function ProductsPage() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
  return (
    <div>
      <NavbarComponent />
      <TitleSection />
      <ProductSection1 />
      <ProductSection2 />
      <ContactSection />
      <FooterComponent />
    </div>
  )
}
